import { Sparkles, Instagram, Facebook, Music2 } from "lucide-react";

const socialLinks = [
  {
    Icon: Instagram,
    label: "Instagram do Achados do Dia",
    href: "https://www.instagram.com/_achados_dia_/",
  },
  {
    Icon: Music2,
    label: "TikTok do Achados do Dia",
    href: "https://www.tiktok.com/@_achados_dia_",
  },
  {
    Icon: Facebook,
    label: "Facebook do Achados do Dia",
    href: "https://www.facebook.com/achadosdia",
  },
];

const platformItems = [
  { label: "Início", href: "/" },
  { label: "Cupons de desconto", href: "/cupons" },
  { label: "Como funciona", href: "/tiktok-review-demo" },
  { label: "Lojas parceiras", href: "/" },
  { label: "Contato", href: "mailto:gestao@achadosdia.com.br" },
];

const legalItems = [
  { label: "Política de privacidade", href: "/politica-de-privacidade" },
  { label: "Termos de uso", href: "/termos-de-servico" },
  { label: "Aviso de afiliado", href: "/politica-de-privacidade#afiliado" },
  { label: "Cookies", href: "/politica-de-privacidade#cookies" },
];

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-card/40">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-full bg-[image:var(--gradient-primary)] text-primary-foreground">
              <Sparkles className="h-4 w-4" />
            </span>
            <span className="font-display text-xl">
              Achados<span className="text-primary"> do Dia</span>
            </span>
          </div>
          <p className="mt-3 max-w-md text-sm text-muted-foreground">
            O Achados do Dia reúne ofertas, promoções e produtos selecionados de
            lojas parceiras. Nosso objetivo é facilitar sua busca pelos melhores
            achadinhos da internet.
          </p>
          <div className="mt-4 flex gap-2">
            {socialLinks.map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                target="_blank"
                rel="noopener noreferrer"
                className="grid h-9 w-9 place-items-center rounded-full border border-border bg-background hover:bg-secondary"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <FooterCol title="Plataforma" items={platformItems} />
        <FooterCol title="Legal" items={legalItems} />
      </div>

      <div className="border-t border-border/60">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-5 md:px-6">
          <p className="text-[11px] leading-relaxed text-muted-foreground">
            O Achados do Dia participa de programas de afiliados. Ao clicar em
            alguns links, podemos receber uma comissão, sem custo adicional para
            você.{" "}
            <span>© {new Date().getFullYear()} Achados do Dia.</span>
          </p>
          <nav aria-label="Links do rodapé" className="flex shrink-0 gap-4 text-[11px] font-medium text-muted-foreground">
            <a href="/termos-de-servico" className="hover:text-primary underline underline-offset-2">
              Termos de Serviço
            </a>
            <a href="/politica-de-privacidade" className="hover:text-primary underline underline-offset-2">
              Política de Privacidade
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  title,
  items,
}: {
  title: string;
  items: { label: string; href: string }[];
}) {
  return (
    <div>
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-foreground/80">
        {title}
      </p>
      <ul className="space-y-2 text-sm text-muted-foreground">
        {items.map((item) => (
          <li key={item.label}>
            <a href={item.href} className="hover:text-primary">
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
